<app-layout>
	<div class="main-container">
		<div class="content">
			<div class="main-content">
				<mat-card>
					<mat-card-title class="header">
						<div class="title-section">
							<h1>
								{{ 'Documents' | translate: {Default: "Documents"} }}
							</h1>
						</div>
						<div class="action-buttons">
							<button mat-flat-button class="action-button" setColor="primaryColour" color="primary"
									appPreventDoubleClick (throttledClick)="openFileDialog()"
									[disabled]="isLoading || isUploadingFile || !canModifyDocuments()"
									*ngIf="canModifyDocuments()">
								<mat-icon class="material-icons-outlined" aria-label="add icon">add</mat-icon>
								<span class="button-text">{{ 'AddFile' | translate: {Default: "Add File"} }}</span>

							</button>

							<button mat-icon-button class="action-button folder-button"
									matTooltip="{{ 'AddFolder' | translate: {Default: 'Add Folder'} }}" appPreventDoubleClick (throttledClick)="openFolderDialog()"
									[disabled]="isLoading || isCreatingFolder || !canModifyDocuments()"
									*ngIf="canModifyDocuments()">
								<mat-icon class="material-icons-outlined"
										  *ngIf="!isCreatingFolder">create_new_folder
								</mat-icon>
							</button>
						</div>
					</mat-card-title>

					<mat-card-content>
						<div class="breadcrumbs">
							<kendo-breadcrumb
								collapseMode="wrap"
								[items]="breadcrumbs"
								(itemClick)="onBreadcrumbClick($event)"
							></kendo-breadcrumb>
						</div>
						<app-data-grid-comp
							class="documents-manager-grid"
							[gridId]="gridId"
							hideActionButtons="true"
							[columns]="columns"
							[filterCategories]="filterCategories"
							[sortableColumns]="sortableColumns"
							[sortable]="{
								mode: 'multiple'
							}"
							[gridDataResult]="gridDataResult"
							[isLoading]="isLoading"
							[pageSize]="pageSize"
							[skip]="skip"
							[rowSelectionSettings]="rowSelectionSettings"
							clickableRows="true"
							searchable="true"
							[clearSelectedItems]="clearSelectedItems"
							[rowActionButtons]="gridActionButtons"
							(rowActionEvent)="actionButtonClicked($event)"
							(emitOpenDialogEvent)="navigateToFolder($event)"
							(emitDeleteEvent)="deleteAllSelected($event)"
							(emitGridStateChangeEvent)="gridStateChange($event)"
						></app-data-grid-comp>

						<!-- <kendo-grid [data]="gridView" [pageSize]="pageSize" [skip]="skip" [pageable]="true"
									[sortable]="false" [reorderable]="true" [resizable]="true"
									[loading]="isLoading || isDeletingItem || isUploadingFile || isCreatingFolder || isUpdatingItem" (pageChange)="pageChange($event)"
									(sortChange)="sortChange($event)">

							<kendo-grid-column field="name" title="{{ 'Name' | translate: {Default: 'Name'} }}" [sortable]="false"
											   [width]="250">
								<ng-template kendoGridCellTemplate let-dataItem>
									<div class="name-cell" [class.clickable]="dataItem.isFolder"
										 appPreventDoubleClick (throttledClick)="dataItem.isFolder ? navigateToFolder(dataItem) : null">
										<ng-container *ngIf="dataItem.isFolder; else fileIcon">
												<img
													class="ms-icon"
													src="assets/icons/folder.svg"
													style="width: 30px;
															height: 30px;
															vertical-align: middle;">
										</ng-container>
										<ng-template #fileIcon>
											<ng-container *ngIf="icons[dataItem.contentType]; else blankIcon">
												<img
													class="ms-icon"
													src={{icons[dataItem.contentType]}}
													style="width: 30px;
															height: 30px;
															vertical-align: middle;">
											</ng-container>
											<ng-template #blankIcon>
												<mat-icon class="blank-document-icon material-icons-outlined">description</mat-icon>
											</ng-template>
										</ng-template>
										<span>{{ dataItem.name }}</span>
									</div>
								</ng-template>
							</kendo-grid-column>

							<kendo-grid-column field="status" title="{{ 'Status' | translate: {Default: 'Status'} }}" [width]="120" [sortable]="false">
								<ng-template kendoGridCellTemplate let-dataItem>
									<mat-chip-set>
										<mat-chip 
											[ngClass]="{
												'red-chip': dataItem.status?.id === 'ARCHIVED',
												'green-chip': dataItem.status?.id === 'PUBLISHED',
												'orange-chip': dataItem.status?.id === 'DRAFT'
											}"
										>{{ dataItem.status?.name }}</mat-chip>
									</mat-chip-set>
								</ng-template>
							</kendo-grid-column>

							<kendo-grid-column field="fileSize" title="{{ 'FileSize' | translate: {Default: 'File Size'} }}" [width]="100" [sortable]="false">
								<ng-template kendoGridCellTemplate let-dataItem>
									<ng-container *ngIf="dataItem.fileSize !== null">
										{{ dataItem.fileSize | filesize }}
									</ng-container>
								</ng-template>
							</kendo-grid-column>

							<kendo-grid-column field="version.createdBy" title="{{ 'CreatedBy' | translate: {Default: 'Created By'} }}"
											   [width]="150" [sortable]="false">
								<ng-template kendoGridCellTemplate let-dataItem>
									{{ dataItem.version?.createdBy?.firstName }} {{
                                        dataItem.version?.createdBy?.lastName
									}}
								</ng-template>
							</kendo-grid-column>

							<kendo-grid-column field="version.createdOn" title="{{ 'CreatedOn' | translate: {Default: 'Created On'} }}"
											   [width]="150" [sortable]="false">
								<ng-template kendoGridCellTemplate let-dataItem>
									{{ dataItem.version?.createdOn | date:'short' }}
								</ng-template>
							</kendo-grid-column>

							<kendo-grid-column title="{{ 'Actions' | translate: {Default: 'Actions'} }}" [width]="120" [sortable]="false">
								<ng-template kendoGridCellTemplate let-dataItem>
									<button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="isDeletingItem"
											*ngIf="hasAnyActions(dataItem)">
										<mat-icon class="material-icons-outlined">more_vert</mat-icon>
									</button>
									<mat-menu #menu="matMenu">
										<button mat-menu-item appPreventDoubleClick (throttledClick)="downloadFile(dataItem)"
												*ngIf="!dataItem.isFolder"
												[disabled]="isDeletingItem">
											<mat-icon class="material-icons-outlined">download</mat-icon>
											<span>{{ 'Download' | translate: {Default: "Download"} }}</span>
										</button>
										<button mat-menu-item appPreventDoubleClick (throttledClick)="getFileDetails(dataItem)"
												[disabled]="isDeletingItem || isUpdatingItem || !canModifyDocuments()"
												*ngIf="canModifyDocuments()">
											<mat-icon class="material-icons-outlined">edit</mat-icon>
											<span>{{ 'Edit' | translate: {Default: "Edit"} }}</span>
										</button>
										<button mat-menu-item appPreventDoubleClick (throttledClick)="deleteItem(dataItem)" class="delete-button"
												[disabled]="isDeletingItem || !canModifyDocuments()"
												*ngIf="canModifyDocuments()">
											<mat-icon class="material-icons-outlined"
													  *ngIf="!isDeletingItem">delete
											</mat-icon>
											<mat-progress-spinner *ngIf="isDeletingItem" diameter="16"
																  mode="indeterminate">
											</mat-progress-spinner>
											<span>{{ 'Delete' | translate: {Default: "Delete"} }}</span>
										</button>
									</mat-menu>
								</ng-template>
							</kendo-grid-column>

							<kendo-grid-messages
									[noRecords]="isLoading ? '' : translate.instant('Grid-NoRecordsAvailable')"></kendo-grid-messages>
						</kendo-grid>-->
					</mat-card-content> 
				</mat-card>

			</div>
		</div>
	</div>
</app-layout>
